import { AddMiniIcon } from '@calendly/ui/components/icons'
import { MinimalButton } from '@calendly/ui/components/minimal-button'

export const AddButton = ({ children, ...props }) => (
  <div>
    <MinimalButton
      fontSize="small"
      {...props}
    >
      <AddMiniIcon />
      {children}
    </MinimalButton>
  </div>
)
